/**
* 基础菜单 商品管理
*/
<template>
  <div class="contianer">
    <!-- 面包屑导航 -->
    <!-- <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>店铺管理</el-breadcrumb-item>
        <el-breadcrumb-item>店铺信息管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
    <div class="address">
      <div class="ment flex_box ">
        <p class="text f20 fontWeight">店铺信息</p>
        <el-row>
          <el-button type="primary" plain size="mini" @click="edit">编辑</el-button>
        </el-row>
      </div>

      <div class="mt20">
        <el-descriptions title="" :column="1" border>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 70px">店铺名称</div>
            </template>
            {{tableData.name}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 70px; height: 136px">店铺logo</div>
            </template>
            <el-image
              style="width: 120px; height: 120px"
              :src="tableData.logo_img_url"
              :preview-src-list="srcList">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </div>

    <!-- 弹窗 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="修改店铺信息"
               :visible.sync="editDialogVisible"
               width="30%"
               center>
      <el-form label-width="120px" :model="addshopForm" :rules="rules" ref="addshopForm" class="addshopForm">
        <el-form-item label="店铺名称" prop="name">
          <el-input size="small" v-model="addshopForm.name" placeholder="请输入店铺名称" clearable maxlength="20"></el-input>
        </el-form-item>

        <el-form-item label="店铺logo" prop="logo_img_url" class="list_pic_url">
          <el-upload
            class="avatar-uploader"
            action="#"
            :on-remove="handleRemove"
            :show-file-list="false"
            :http-request="handleUpload"
            :before-upload="beforeUpload"
          >
            <img v-if="form.image" :src="form.image" class="avatar"/>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <div style="color: red;font-size: 12px;margin-left: 118px">
          图片尺寸260px*260px，单张图片大小不得超过1M，仅支持jpg、jpeg、png格式
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="sure('addshopForm')" :disabled="!isCanSubmit">确 定</el-button>
            <el-button @click="editDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    shopInfo,    // 详情
    shopAdd,     // 新增
    shopUpdate   // 修改
  } from '../../api/basisMG'
  import {getToken, upload, uploadImgTmp} from '../../api/commonMG'
  import Pagination from '../../components/Pagination'
  import {uploadFile} from "../../utils/util";

  export default {
    data: () => {
      return {
        loading: false, //是显示加载
        editDialogVisible: false, //控制页面显示与隐藏
        imgUrl: '',
        dialogImageUrl: '',
        dialogVisible: false,
        srcList: [],
        tableData: {
          id: '',
          name: '',
          logo_img_id: '',
          logo_img_url: '',
        },
        addshopForm: {
          id: '',
          name: '',
          logo_img_id: '',
          logo_img_url: '',
        },
        // rules表单验证
        rules: {
          name: [{required: true, message: '请输入店铺名称', trigger: 'blur'}],
          logo_img_url: [{required: true, message: '请输入店铺logo', trigger: 'blur'}]
        },
        form: {
          image: ''
        },
        id: '',
        isCanSubmit: true,
      }
    },
    // 注册组件
    components: {},

    /**
     * 创建完毕
     */
    created() {
      this.getdata()
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        shopInfo()
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if(res.content) {
                this.tableData = res.content;
                this.srcList.push(res.content.logo_img_url)
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      edit() {
        this.editDialogVisible = true;
        this.addshopForm = this.tableData;
        this.form.image = '';
        this.imgUrl = '';
        shopInfo()
          .then(res => {
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if(res.content) {
                let data = res.content;
                this.addshopForm = {
                  name: data.name,
                  id:data.id,
                  logo_img_id:data.logo_img_id,
                  logo_img_url: data.logo_img_url
                }
                this.imgUrl = data.logo_img_url
                this.form.image = data.logo_img_url
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试!')
          })
      },
      sure(formName) {
        this.addshopForm.logo_img_url = this.imgUrl;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isCanSubmit = false;
            this.loading = true;
            if(this.addshopForm.id) {
              shopUpdate(this.addshopForm)
                .then(res => {
                  this.isCanSubmit = true;
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '保存成功!'
                    })
                    this.editDialogVisible = false;
                    this.getdata()
                  }
                })
                .catch(err => {
                  this.isCanSubmit = true;
                  this.loading = false
                  this.$message.error('网络错误,请稍后再试!')
                })
            } else {
              shopAdd(this.addshopForm)
                .then(res => {
                  this.isCanSubmit = true;
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '保存成功!'
                    })
                    this.editDialogVisible = false;
                    this.getdata()
                  }
                })
                .catch(err => {
                  this.isCanSubmit = true;
                  this.loading = false
                  this.$message.error('网络错误,请稍后再试!')
                })
            }

          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      handleRemove(file) {
        console.log(file);
      },
      // 限制图片尺寸
      limitFileWH(E_width, E_height, file) {
        const _this = this
        let imgWidth = ''
        let imgHight = ''
        const isSize = new Promise(function (resolve, reject) {
          const width = E_width
          const height = E_height
          const _URL = window.URL || window.webkitURL
          const img = new Image()
          img.onload = function () {
            imgWidth = img.width
            imgHight = img.height
            const valid = img.width === width && img.height === height
            valid ? resolve() : reject()
          }
          img.src = _URL.createObjectURL(file)
        }).then(() => {
          // const fileData = new FormData();
          // fileData.append("image", file);
          // //upload为上传的接口
          // upload(fileData).then(res => {
          //   this.imgUrl = res.attrs.file_url;
          //   //对返回的图片地址进行回显
          //   this.$set(this.form, "image", res.attrs.file_url);
          // });
          getToken().then(res => {
            if(res) {
              let result = uploadFile(res,file);
              result.then(res => {
                this.imgUrl =  res.data.content.file.fileUrl;
                //对返回的图片地址进行回显
                this.$set(this.form, "image",  res.data.content.file.fileUrl);
              })
            }
          });
          //阻止传到本地浏览器
          return false;
        }, () => {
          _this.$message.error({
            message: '上传图片的尺寸应为' + E_width + '*' + E_height + '，当前上传图片的尺寸为：' + imgWidth + '*' + imgHight,
            btn: false
          })
          return false
        })
        return isSize
      },
      beforeUpload(file) {
        const isJPG = file.type === "image/jpeg" || file.type == "image/png";
        const isLt2M = file.size / 1024 / 1024 < 1;
        // if (!isJPG) {
        //   this.$message.error("上传图片只能是 JPG 或 PNG 格式!");
        //   return;
        // }
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 1MB!");
          return;
        }
        // 调用[限制图片尺寸]函数
        this.limitFileWH(260, 260, file)
      },
      // 可以获取图片参数
      handleUpload(file) {
        console.log(file)
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.order_code == cell.innerText || row.mobile == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      },
    }
  }
</script>


<style scoped>
  .contianer {
    height: calc(100% - 60px);
    background: #fff;
    padding: 20px;
    border-radius: 8px;
  }

  /deep/ .textarea .el-textarea__inner {
    height: 120px;
    width: 320px;
    resize: none;
  }

  /deep/ .addshopForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .addshopForm .el-input--small {
    width: 320px;
  }

  .mt20 {
    margin-top: 20px;
  }

  .f20 {
    font-size: 20px;
  }

  .fontWeight {
    font-weight: 600;
  }

  .flex_box {
    display: flex;
  }

  .flex_box {
    display: flex;
  }

  .billing_item span {
    height: 40px;
    padding-left: 12px;
    padding-right: 15px;
    width: 300px;
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
  }

  .copy {
    width: 20px;
    height: 20px;
  }

  .copy img {
    width: 20px;
    height: 20px;
  }

  .saleTitle {
    color: #333333;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 12px;
    margin-top: 25px;
  }

  .picTitle {
    color: #333333;
    font-size: 15px;
    font-weight: 400;
    margin: 20px 0;
  }

  /deep/ .delivery .el-form-item {
    margin-left: 25%;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  .address {
    width: 500px;
    height: 168px;
    margin: 30px 0 0 36px;
  }

  .ment {
    padding: 2px 12px;
    justify-content: space-between;
  }

  .text {
    font-family: 'PingFang SC';
    font-style: normal;
    line-height: 28px;
    color: #409EFF;
  }

  .w120 {
    width: 120px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar {
    width: 120px;
    height: 120px;
    display: block;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    border: 1px dashed #DCDFE6;
  }

  .avatar-uploader {
    height: 122px;
  }

  /deep/ .image-slot {
    text-align: center;
    margin-top: 50%;
    transform: translateY(-50%);
  }

  /deep/ .el-descriptions-row th {
    width: 120px !important;
    border: 0 !important;
    border-bottom: 1px solid #EBEEF5 !important;
    background: #F5F7FA;
  }

  /deep/ .el-descriptions-row td {
    border: 0 !important;
    border-bottom: 1px solid #EBEEF5 !important;
  }

</style>





// WEBPACK FOOTER //
// src/views/store/storeMessage.vue